import { Box } from "@mui/material"
import dayjs, { Dayjs } from "dayjs"
import { Ref, forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { toUnitTimeZone } from "../../../../utils/methods/calcDate"
import { Constants } from "../../../../utils/constants"
import { DateModalSimpleWithoutDate } from "../simple"


/* import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Activar los plugins
dayjs.extend(utc);
dayjs.extend(timezone); */

const useStyles = () => {
    return {
        container: {
            display: 'flex',
            gap: '20px'
        }
    }
}
type DateRangeWithoutDateProps = {
    from?: Dayjs | null;
    to?: Dayjs | null;
    setDate?: (payload: { target: { name: string; value: Dayjs } }) => void
    defaultErrors?: {
        to: string;
        from: string;
    }
    mimTimeZone?: {
        code: string;
        value: number;
    }
    buttonTitle: string;
    isFrom:boolean,
    title:string,
    toName?:string,
    fromName?:string,
    isDateForm:boolean,
    haveMinMax:boolean,
    isRequired?:boolean
}
type DateRangeWithoutDateRef = {
    getRange: () => { from?: Dayjs | null; to?: Dayjs | null }
    updateRange: (payload: { from?: Dayjs | null; to?: Dayjs | null }) => void
}
const DateRangeWithoutDate = forwardRef((props: DateRangeWithoutDateProps, ref: Ref<DateRangeWithoutDateRef>) => {
    const styles = useStyles()
    const [defaulValues, setDefaultValues] = useState<{ from?: Dayjs | null; to?: Dayjs | null }>({ from: dayjs(props.from), })
    const [errors, setErrors] = useState({ to: false, from: false })
    const [isToBiggerThanFrom, setIsToBiggerThanFrom] = useState(dayjs(defaulValues.to).date() > dayjs(defaulValues.from).date())
    const formatInitialDate = dayjs(toUnitTimeZone(new Date(), props?.mimTimeZone?.value ?? Constants.defaultTimeZoneObject.value,))
    const getDate = (date: Dayjs, name:string /* 'to' | 'from' */) => {
        setErrors(prev => ({ ...prev, [name]: false }))
        const originalDate = dayjs(date)
        const newDate = originalDate.second(0).millisecond(0) //Para eliminar los segundos
        if (props.setDate) {
            props.setDate({ target: { name, value: newDate } })
        }
        setDefaultValues(prev => ({ ...prev, [name]: newDate }))
    }

    useImperativeHandle(ref, () => ({
        getRange: () => {
            setErrors(prev => ({ ...prev, from: !defaulValues.from, to: !defaulValues.to }))
            return defaulValues
        },
        updateRange: (payload) => {
            setDefaultValues(payload)
        }
    }))
    
    useEffect(() => {
        setDefaultValues({
            to: props.to, from: props.from
        })

    }, [props.to, props.from])
    return (
        <Box sx={styles.container}>
            <DateModalSimpleWithoutDate
                timeZone={props?.mimTimeZone?.code ?? Constants.defaultTimeZone}
                setIsToBiggerThanFrom={setIsToBiggerThanFrom}
                buttonTitle={props.isRequired ? `${props.buttonTitle}*` :props.buttonTitle}
                errorMsg={props.isFrom ? props?.defaultErrors?.from : props?.defaultErrors?.to}
                defaultDate={props.isFrom ? defaulValues.from : defaulValues.to}
                error={props.isFrom ? !!(props?.defaultErrors?.from ?? errors.from) : !!(props?.defaultErrors?.to ?? errors.to)}
                getDate={(date) => { props.isFrom ? getDate(date, props.fromName ?? 'from') : getDate(date, props.toName ?? 'to') }}
                payload={{
                    max: !props.haveMinMax ? null : props.isFrom ? defaulValues.to : null,
                    min: !props.haveMinMax ? null : props.isFrom ? formatInitialDate : defaulValues.from ?? dayjs(toUnitTimeZone(new Date(), props?.mimTimeZone?.value ?? Constants.defaultTimeZoneObject.value,)),
                    is: props.isFrom ? { start: true, startLower: isToBiggerThanFrom } : { end: true, endBigger: isToBiggerThanFrom },
                    isDateForm: props.isDateForm
                }}
                title={props.title} name= {props.isFrom ? 'from' : 'to'} />

            {/* <DateModalSimple
                timeZone={props?.mimTimeZone?.code ?? Constants.defaultTimeZone}
                setIsToBiggerThanFrom={setIsToBiggerThanFrom}
                buttonTitle="Hasta *"
                errorMsg={props?.defaultErrors?.to}
                defaultDate={defaulValues.to}
                error={!!(props?.defaultErrors?.to ?? errors.to)}
                getDate={(date) => { getDate(date, 'to') }}
                payload={{
                    min: defaulValues.from ?? dayjs(toUnitTimeZone(new Date(), props?.mimTimeZone?.value ?? Constants.defaultTimeZoneObject.value,)),
                    is: { end: true, endBigger: isToBiggerThanFrom }
                }}
                title='SELECCIÓN DE FECHA DE FIN' name="to"
            /> */}
        </Box>
    )
})

export { DateRangeWithoutDate }
export type { DateRangeWithoutDateRef }

